import api from '../config/axios';

export const getStats = () => api.get('/dashboard/stats');
export const getStatusDistribution = () => api.get('/dashboard/status-distribution');
export const getBankWise = () => api.get('/dashboard/bank-wise');
export const getMonthlyTrends = (year) => api.get(`/dashboard/monthly-trends?year=${year}`);
export const getPerformance = () => api.get('/dashboard/performance');
export const getSlaReport = () => api.get('/dashboard/sla-report');
